"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CSS = _interopRequireDefault(require("./CSS"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _CSS["default"])({
  row: 'flex flex-wrap -mx2',
  col1: 'w-1/12 p-2',
  col2: 'w-2/12 p-2',
  col3: 'w-3/12 p-2',
  col4: 'w-4/12 p-2',
  col5: 'w-5/12 p-2',
  col6: 'w-6/12 p-2',
  col7: 'w-7/12 p-2',
  col8: 'w-8/12 p-2',
  col9: 'w-9/12 p-2',
  col10: 'w-10/12 p-2',
  col11: 'w-11/12 p-2',
  col12: 'w-full p-2'
});

exports["default"] = _default;